import "./_tournament-brackets.scss";

document.addEventListener("DOMContentLoaded", () => {
  // Selezioniamo tutti i blocchi bracket sulla pagina
  const bracketBlocks = document.querySelectorAll(
    ".block__tournament-brackets",
  );

  bracketBlocks.forEach((block) => {
    const scrollArea = block.querySelector(".bracket-scroll-area");
    const tabsContainer = block.querySelector(".bracket-tabs-container");

    if (scrollArea && tabsContainer) {
      // Sincronizziamo lo scroll orizzontale
      scrollArea.addEventListener("scroll", () => {
        tabsContainer.scrollLeft = scrollArea.scrollLeft;
      });
    }
  });
});
